import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ConfirmationDialogProps } from '../../@types/Components';
import { deleteButton, immersightButton } from '../../utils/colors';

const ConfirmationDialog = ({
    cancelId = 'ConfirmationDialog.cancel',
    destructive = false,
    confirmId = 'ConfirmationDialog.confirm',
    open,
    onClose,
    onConfirm,
    titleId,
    messageId
}: ConfirmationDialogProps): JSX.Element => (
    <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            <FormattedMessage id={titleId} />
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                <FormattedMessage id={messageId} />
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={onClose}
                variant="contained"
                sx={{
                    backgroundColor: destructive ? immersightButton : deleteButton
                }}
            >
                <FormattedMessage id={cancelId} />
            </Button>
            <Button
                onClick={onConfirm}
                variant="contained"
                sx={{
                    backgroundColor: destructive ? deleteButton : immersightButton
                }}
                autoFocus
            >
                <FormattedMessage id={confirmId} />
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmationDialog;
